import InlineStyled from '../InlineStyled/InlineStyled';

const AppCard1 = ({ children, className = '' }) => {
  return (
    <InlineStyled
      className={className}
      $style={{
        padding: 24,
        borderRadius: 24,
        border: '1px solid rgba(0, 0, 0, 0.10)',
        background: '#fff',
        width: '100%',
      }}
    >
      {children}
    </InlineStyled>
  );
};

export default AppCard1;
